export default {
    path: ":alias/brands/activity",
    component: resolve => require(["@/views/activity"], resolve),
    children: [
      {
        path: "list",
        component: resolve => require(["@/views/activity/list"], resolve)
      },
      {
        path: "list/form/:id?",
        component: resolve => require(["@/views/activity/form"], resolve)
      }
    ]
  };
  